import { render, staticRenderFns } from "./SeatStatistics.vue?vue&type=template&id=affcc69a&scoped=true&"
import script from "./SeatStatistics.vue?vue&type=script&lang=js&"
export * from "./SeatStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SeatStatistics.vue?vue&type=style&index=0&id=affcc69a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affcc69a",
  null
  
)

export default component.exports